import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import { generatePath } from "react-router-dom";
import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../enums/notificationTypes";
import axiosInstance from "../../interceptor/axiosInstance";
import {
  InstituteTutorFiltersModel,
  InstituteTutorModel,
} from "../../models/InstituteModel/tutor.model";
import {
  INSTITUTE_TUTORS,
  INSTITUTE_TUTORS_BULK,
  INSTITUTE_TUTOR_DETAILS,
} from "../../routes/routeConstants/apiRoutes";
import Notification from "../../shared/components/Notification";

export class InstituteTutorService {
  static fetchInstituteTutors(
    params: any,
    onSuccess: (tutors: InstituteTutorModel[], total_tutors) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const serializeParams = serialize(InstituteTutorFiltersModel, params);
    return axiosInstance
      .get(INSTITUTE_TUTORS, { params: serializeParams })
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutors"]["tutors"]
        ) as InstituteTutorModel[];

        onSuccess(data, response['data']['total_tutors']);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching tutors",
          description: "Please try again",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(onFinal);
  }
  static createInstituteTutor(
    tutor: any,
    onSuccess: (tutor: InstituteTutorModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .post(INSTITUTE_TUTORS, tutor, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutor"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        const {response} = error;
        Notification({
          message: "Failed",
          description: response?.data?.error,
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(onFinal);
  }
  static updateInstituteTutor(
    tutorId: number,
    tutor: any,
    onSuccess: (tutor: InstituteTutorModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .put(generatePath(INSTITUTE_TUTOR_DETAILS, { tutorId }), tutor)
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutor"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        const {response} = error;
        Notification({
          message: "Failed",
          description: response?.data?.error,
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(onFinal);
  }
  static updatePassword(
    tutorId: number | undefined,
    password: string,
    onSuccess: Function,
  ) {
    const payload = { tutor: { password: password }};
    axiosInstance
      .put(generatePath(ApiRoutes.INSTITUTE_TUTOR_PASSWORD_UPDATE, { tutorId }), payload)
      .then(() => {
        Notification({ message: "Password", description: "Password updated successfully", type: NotificationTypes.SUCCESS });
        onSuccess()
      })
      .catch((error) => {
        Notification({
          message: `${error?.response?.data?.error || "Problem in updating student password"}`,
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
      })
  }
  static deleteInstituteTutor(
    tutorId: number,
    onSuccess: (tutor: InstituteTutorModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .delete(generatePath(INSTITUTE_TUTOR_DETAILS, { tutorId }))
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutor"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        Notification({
          message: "Problem in deleting tutor",
          description: "Please try again",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(onFinal);
  }
  static createBulkInstituteTutors(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .post(INSTITUTE_TUTORS_BULK, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutor"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating tutors",
          description: "Please try again",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(onFinal);
  }
  static fetchInstituteTutor(
    tutorId: number,
    onSuccess: (tutor: InstituteTutorModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .get(generatePath(INSTITUTE_TUTOR_DETAILS, { tutorId }))
      .then((response) => {
        const data = deserialize(
          InstituteTutorModel,
          response?.["data"]?.["tutor"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching tutor",
          description: "Please try again",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(onFinal);
  }
}
